export const HeroBackground = () => {
  return (
    <div className="absolute inset-0 bg-igbanwo-mint/5 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(#5fcc9c_1px,transparent_1px)] [background-size:20px_20px] opacity-20"></div>
    </div>
  );
};
